import React from 'react'
import styles from './CustomCheckbox.module.css'

const CustomCheckbox = ({ label, name, checked, onChange, error }) => {
  return (
    <div className={styles["checkbox-wrapper-12"]}>
      <div className={styles["cbx"]}>
        <input name={name} checked={checked} className={error ? styles['error'] : styles['']} onChange={onChange} type="checkbox" id={styles["cbx-12"]} />
        <label htmlFor={styles["cbx-12"]}></label>
        <svg fill="none" viewBox="0 0 15 14" height="12" width="12">
          <path d="M2 8.36364L6.23077 12L13 2"></path>
        </svg>
      </div>
      <p>{label}</p>
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <filter id="goo-12">
            <feGaussianBlur result="blur" stdDeviation="4" in="SourceGraphic"></feGaussianBlur>
            <feColorMatrix result="goo-12" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 22 -7" mode="matrix" in="blur"></feColorMatrix>
            <feBlend in2="goo-12" in="SourceGraphic"></feBlend>
          </filter>
        </defs>
      </svg>
    </div>
  )
}

export default CustomCheckbox